<template>
  <div class="hello">
    <SeedJung_Header></SeedJung_Header>
    <div class="register-container">
      <h1 class="register-title">회원가입</h1>
      <form class="register-form" @submit.prevent="register">
        <div class="form-group">
          <label>닉네임</label>
          <div class="input-group">
            <input v-model="nickname" placeholder="닉네임" type="text">
            <button type="button" class="check-btn" @click="checkNickname">중복확인</button>
          </div>
        </div>
        <div class="form-group">
          <label>아이디</label>
          <div class="input-group">
            <input v-model="username" placeholder="아이디" type="text" autocapitalize="none" autocorrect="off">
            <button type="button" class="check-btn" @click="checkUsername">중복확인</button>
          </div>
        </div>
        <div class="form-group">
          <label>비밀번호*</label>
          <input v-model="password" placeholder="비밀번호" type="password">
        </div>
        <div class="form-group">
          <label>비밀번호 확인*</label>
          <input v-model="passwordConfirm" placeholder="비밀번호 확인" type="password">
          <span class="password-hint">※ 공백없이 8~20자의 영문 소문자, 특수문자, 숫자로만 사용 할 수 있습니다.</span>
        </div>
        <div class="form-group">
          <label>이메일*</label>
          <div class="email-group">
            <input v-model="email" type="text" placeholder="이메일" class="email-input">
            <span class="at-symbol" style="display: none;">@</span>
            <input v-model="emailDomain" type="text" class="domain-input" style="display: none;" readonly>
            <select class="email-select" v-model="emailDomain">
              <option value="">직접입력</option>
              <option value="naver.com">naver.com</option>
              <option value="gmail.com">gmail.com</option>
              <!-- 다른 옵션들... -->
            </select>
          </div>
          <button type="button" class="check-btn email-check" @click="checkEmail">중복확인</button>
        </div>
        <p class="terms-agreement">회원가입을 하시는 것은 이용약관 및 개인정보보호에 동의하시는 것을 의미합니다.</p>
        <div class="button-group">
          <button type="submit" class="submit-btn">가입</button>
          <button type="button" class="cancel-btn">취소</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue'
import axios from 'axios'

export default {
  name: 'SeedJung_Regist',
  components: {
    SeedJung_Header
  },
  data() {
    return {
      nickname: '',
      username: '',
      password: '',
      passwordConfirm: '',
      email: '',
      emailDomain: '',
      isNicknameAvailable: false,
      isUsernameAvailable: false,
      isEmailAvailable: false,
      customEmailDomain: '',
    }
  },

  methods: {
    validateNickname() {
      if (this.nickname.length < 2) {
        alert('닉네임은 2글자 이상이어야 합니다.');
        return false;
      }

      // 한글 자음 또는 모음만으로 이루어진 문자열 체크
      const koreanJamoRegex = /^[ㄱ-ㅎㅏ-ㅣ]+$/;
      if (koreanJamoRegex.test(this.nickname)) {
        alert('닉네임에 자음 또는 모음만 사용할 수 없습니다.');
        return false;
      }

      // 유효한 문자만 포함되어 있는지 체크 (한글, 영문, 숫자)
      const validCharRegex = /^[가-힣a-zA-Z0-9]+$/;
      if (!validCharRegex.test(this.nickname)) {
        alert('닉네임은 한글, 영문, 숫자만 사용 가능합니다.');
        return false;
      }

      return true;
    },

    validatePasswords() {
      if (this.password !== this.passwordConfirm) {
        alert('비밀번호가 일치하지 않습니다.');
        return false;
      }
      return true;
    },

    validateUsername() {
      if (this.username.length < 4) {
        alert('아이디는 4글자 이상이어야 합니다.');
        return false;
      }
      
      const usernameRegex = /^[a-zA-Z0-9]{4,20}$/;
      if (!usernameRegex.test(this.username)) {
        alert('아이디는 4~20자의 영문과 숫자만 사용 가능합니다.');
        return false;
      }
      return true;
    },
    
    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      let fullEmail;

      if (this.emailDomain === '') {
        // 직접 입력 모드
        fullEmail = this.email;
      } else {
        // 도메인 선택 모드
        fullEmail = this.email + '@' + this.emailDomain;
      }

      if (!emailRegex.test(fullEmail)) {
        alert('올바른 이메일 형식이 아닙니다.');
        return false;
      }
      return true;
    },

    async checkNickname() {
      if (!this.validateNickname()) return;
      try {
        const response = await axios.post('/api/check-nickname', {
          nickname: this.nickname
        });
        if (response.data.available) {
          alert('사용 가능한 닉네임입니다.');
          this.isNicknameAvailable = true;
        } else {
          alert('이미 사용 중인 닉네임입니다.');
          this.isNicknameAvailable = false;
        }
      } catch (error) {
        console.error('닉네임 중복 확인 실패:', error);
        alert('닉네임 중복 확인에 실패했습니다. 다시 시도해주세요.');
      }
    },

    async checkUsername() {
      if (!this.validateUsername()) return;
      try {
        const response = await axios.post('/api/check-username', {
          username: this.username
        });
        if (response.data.available) {
          alert('사용 가능한 아이디입니다.');
          this.isUsernameAvailable = true;
        } else {
          alert('이미 사용 중인 아이디입니다.');
          this.isUsernameAvailable = false;
        }
      } catch (error) {
        console.error('아이디 중복 확인 실패:', error);
        alert('아이디 중복 확인에 실패했습니다. 다시 시도해주세요.');
      }
    },

    async checkEmail() {
      if (!this.validateEmail()) return;
      try {
        const fullEmail = this.email + '@' + (this.emailDomain || this.customEmailDomain);
        const response = await axios.post('/api/check-email', {
          email: fullEmail
        });
        if (response.data.available) {
          alert('사용 가능한 이메일입니다.');
          this.isEmailAvailable = true;
        } else {
          alert('이미 사용 중인 이메일입니다.');
          this.isEmailAvailable = false;
        }
      } catch (error) {
        console.error('이메일 중복 확인 실패:', error);
        alert('이메일 중복 확인에 실패했습니다. 다시 시도해주세요.');
      }
    },

    async register() {
      if (!this.isNicknameAvailable || !this.isUsernameAvailable || !this.isEmailAvailable) {
        alert('닉네임, 아이디, 이메일 중복 확인을 모두 완료해주세요.');
        return;
      }

      if (!this.validateNickname() || !this.validatePasswords() || !this.validateUsername() || !this.validateEmail()) {
        return;
      }
      
      try {
        const fullEmail = this.email + '@' + (this.emailDomain || this.customEmailDomain);
        const response = await axios.post('/api/register', {
          nickname: this.nickname,
          username: this.username,
          password: this.password,
          email: fullEmail
        });
        
        if (response.data.success) {
          alert('회원가입이 완료되었습니다.');
          // 로그인 페이지로 이동
          window.location.href = '/login';
        } else {
          alert(response.data.message || '회원가입에 실패했습니다. 다시 시도해주세요.');
          window.location.href = '/login';
        }
      } catch (error) {
        console.error('회원가입 실패:', error);
        if (error.response && error.response.data) {
          alert(error.response.data.message || '회원가입에 실패했습니다. 다시 시도해주세요.');
        } else {
          alert('서버와의 통신 중 오류가 발생했습니다.');
        }
      }
    }
  },
  mounted() {
    const emailSelect = document.querySelector('.email-select');
    const atSymbol = document.querySelector('.at-symbol');
    const domainInput = document.querySelector('.domain-input');

    emailSelect.addEventListener('change', function() {
      if (this.value) {
        atSymbol.style.display = 'inline';
        domainInput.style.display = 'inline';
        domainInput.value = this.value;
      } else {
        atSymbol.style.display = 'none';
        domainInput.style.display = 'none';
        domainInput.value = '';
      }
    });
  }
}
</script>

<style scoped>
.register-container {
  max-width: 600px;
  margin: 180px auto 50px;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
}

.register-title {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
  font-size: 28px;
}

.register-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 25px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

input, select {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.input-group {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.input-group input {
  flex-grow: 1;
}

.check-btn {
  padding: 12px 20px;
  background-color: #072c53;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.1s;
  font-weight: 500;
  white-space: nowrap;
  min-width: fit-content;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.check-btn:hover {
  background-color: #072c53;
  transform: translateY(-2px);
}

.check-btn:active {
  transform: translateY(0);
}

.password-hint {
  display: block;
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

.email-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.email-group input, .email-group select {
  flex-grow: 1;
}

.email-select {
  min-width: 120px;
}

.at-symbol {
  font-weight: bold;
}

.domain-input {
  flex-grow: 0;
  width: auto;
}

.email-check {
  margin-top: 10px;
  width: 100%;
}

.terms-agreement {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 30px 0;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.submit-btn, .cancel-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s, transform 0.1s;
  font-weight: 500;
}

.submit-btn {
  background-color: #072c53;
  color: white;
}

.submit-btn:hover {
  background-color: #072c53;
  transform: translateY(-2px);
}

.cancel-btn {
  background-color: #f44336;
  color: white;
}

.cancel-btn:hover {
  background-color: #d32f2f;
  transform: translateY(-2px);
}

.submit-btn:active, .cancel-btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .register-title {
    text-align: center;
    color: #333;
    margin-top:40px;
    margin-bottom: 30px;
    font-size: 24px;
  }
  .register-container {
    margin-top: 30px;
    padding: 15px;
    width: 100%;
    background-color: #f0f0f0;
  }

  .email-group {
    flex-direction: column;
  }

  .email-group input, .email-group select {
    width: 100%;
    margin-bottom: 10px;
  }

  .at-symbol, .domain-input {
    display: none !important;
  }

  .email-select {
    display: none;
  }

  .email-input {
    width: 100% !important;
  }

  .email-check {
    width: 100%;
  }

  .button-group {
    flex-direction: column;
  }

  .submit-btn, .cancel-btn {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .input-group {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  .input-group input {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0;
  }

  .input-group .check-btn {
    width: auto;
    padding: 0 15px;
    font-size: 14px;
    white-space: nowrap;
  }
  .hello{}
}
</style>